import SiafLiteApiRepository from "../../external/siafLiteApi";

class ProdutosService {
  constructor() {
    this.urlBase = "/estoque/produtos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filtros) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filtros);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getAllProdutosByCodigo(filtros) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/codigo`).get(
      filtros
    );
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  cadastrarListaProdutos(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lista`).post(body);
  }

  getAllProdutosFornecedores(filtros) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/fornecedores`).get(
      filtros
    );
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  atualizarLista(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      "/lista/nf-entrada",
      body
    );
  }

  desativar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(`/desativar/${id}`);
  }

  getByCodbar(codbar) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/codbar/${codbar}`).get();
  }

  validarCodigoBarras(codbar) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/codigobarras/${codbar}`
    ).get();
  }

  validarCodigoBarrasId(id, codbar) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/codigobarras/${id}/${codbar}`
    ).get();
  }

  atualizarGrade(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body, "grade");
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/resumido`
    ).patch(body);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/detalhado`
    ).patch(body);
  }

  getInventarioDeEstoque(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/inventario`
    ).patch(body);
  }
}

export default ProdutosService;
